import { BaseModel } from './base-model';

export class LgpdExpiration extends BaseModel {
  public daysToExpire: number;

  constructor() {
    super();
    this.daysToExpire = null;
  }
}
